<div class="container poppins">
  <div class="display-flex justify-content-center poppins titulos">
    <h1 class="poppins rec">
      {{"components.recoveryPassword.¿Has olvidado tu contraseña?" | translate}}
    </h1>
  </div>
  <div class="display-flex justify-content-center poppins titulos">
    <h3 class="poppins rec">
      {{"components.recoveryPassword.Te enviaremos un e-mail" | translate}}
    </h3>
  </div>
  <div class="col-md-6 mx-auto">
    <div class="card-body">
      <form (ngSubmit)="recoverPassword()" [formGroup]="recoverForm" novalidate id="form_recover_password">
        <div class="form-group">
          <label class="d-block py-1">
            <input
              id="email-inp"
              type="email"
              class="form-control"
              formControlName="email"
              autocomplete="email"
              placeholder="{{
                'components.recoveryPassword.Email' | translate
              }}"
            />
            <span hidden>{{"components.recoveryPassword.Email" | translate}}</span>
            <small
              [hidden]="
                recoverForm.controls.email.valid ||
                recoverForm.controls.email.untouched
              "
              class="text-danger"
              
            >
              {{"components.recoveryPassword.El email es requerido" | translate}}
            </small>
          </label>
          <button
            id="login-btn"
            class="btn btn-primary w-100 login-button"
            type="submit"
            [disabled]="recoverForm.invalid || isLoading"
          >
            <span>{{"components.recoveryPassword.Enviar" | translate}}</span>
            <i
              class="fas fa-circle-o-notch ms-1 fa-spin"
              [hidden]="!isLoading"
            ></i>
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="display-flex justify-content-center poppins titulos mb-5 acuerdo">
    <p class="poppins" >
      {{"components.recoveryPassword.¡Ya me acuerdo!" | translate}}
      <a
        [routerLink]="[
          '/' +
            (translateService.currentLang === 'es' ? 'es' : 'en') +
            '/ingresar'
        ]"
        >{{"components.recoveryPassword.Iniciar sesión" | translate}}</a
      >
    </p>
  </div>
</div>

<ng-template #exito let-modal>
  <div class="container">
    <div class="col-12" style="padding: 20px 0 20px 0">
      <div class="text-center" style="padding: 20px 0 20px 0">
        <img
          src="favicon.ico"
          width="30"
          height="30"
          style="margin-right: 2%"
          loading="lazy"
          alt="Inviertis"
        />
        <br /><br />
        <h1 style="font-size: 30px" translate>
          <strong translate>components.recoveryPassword.REVISA TU EMAIL</strong>
        </h1>
        <p translate>components.recoveryPassword.¡Ya casi estamos!</p>
        <small style="color: #828282; font-size: 13px" translate>
          components.recoveryPassword.Revisa spam
        </small>
        <div>
          <button
            id="login-btn"
            class="btn btn-primary login-button mt-4"
            (click)="seguirInvirtiendo()"
          >
            <span translate
              >components.recoveryPassword.Seguir invirtiendo</span
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
